import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ name, value }) {
        return (
            <gender-field class='radio-input'>
                <legend>Gender:</legend>
                <label>Female
                    <input
                      checked={value == 'female'}
                      id='female'
                      name={name}
                      type='radio'
                      value='female'
                      onClick={() => this.props.reportInput(name, 'female', null)}
                    />
                </label>
                <label>Male
                    <input
                      checked={value == 'male'}
                      id='male'
                      name={name}
                      type='radio'
                      value='male'
                      onClick={() => this.props.reportInput(name, 'male', null)}
                    />
                </label>
                <p class='error-msg'>{this.props.error}</p>
            </gender-field>
        );
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/fields/gender.js